// Fresh Linear signups are synced from setupNewWorkspace, so this screen only fires the
// manual re-sync (cmd+K) and never doubles up on a workspace that is still onboarding.
export function shouldTriggerLinearSync({
	linearConnected,
	hasBeenSetup,
}: {
	linearConnected: boolean
	hasBeenSetup: boolean
}) {
	return linearConnected && hasBeenSetup
}
